module.exports = __webpack_public_path__ + "static/media/404-error.2e31d3f4.png";